import { type Enum } from '@webapp/infrastructure/types/Enum'

export const A2uiCatalogComponents = {
  BUTTON: 'Button',
  MCP_APP: 'McpApp',
  RATING: 'Rating',
  TABLE: 'Table',
  TABLE_ROW: 'TableRow',
} as const

export type A2uiCatalogComponentEnum = Enum<typeof A2uiCatalogComponents>
